var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logs",attrs:{"id":"chat_log"}},_vm._l((_vm.logs),function(log){return _c('div',{key:log.id},[_c('p',[_vm._v(_vm._s(log.from)+":"+_vm._s(log.text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }